import api from 'api';
import Theme from 'records/Theme';
import { DesignTemplates } from 'records/DesignTemplate';

export const THEMES_GRAPHIC_CATEGORY_ASYNC_ACTION_START = 'THEMES_GRAPHIC_CATEGORY_ASYNC_ACTION_START';
export const THEMES_GRAPHIC_CATEGORY_ASYNC_ACTION_SUCCESS = 'THEMES_GRAPHIC_CATEGORY_ASYNC_ACTION_SUCCESS';
export const THEMES_GRAPHIC_CATEGORY_ASYNC_ACTION_ERROR = 'THEMES_GRAPHIC_CATEGORY_ASYNC_ACTION_ERROR';
export const THEMES_GRAPHIC_CATEGORY_RESET_STATE = 'THEMES_GRAPHIC_CATEGORY_RESET_STATE';

const s3BucketURL = APP_CONFIG.s3BucketURL;

function themesGraphicCategoryAsyncActionStart() {
  return {
    type: THEMES_GRAPHIC_CATEGORY_ASYNC_ACTION_START,
  };
}

function themesGraphicCategoryAsyncActionSuccess(data) {
  return {
    type: THEMES_GRAPHIC_CATEGORY_ASYNC_ACTION_SUCCESS,
    data,
  };
}

function themesGraphicCategoryAsyncActionError(error) {
  return {
    type: THEMES_GRAPHIC_CATEGORY_ASYNC_ACTION_ERROR,
    error,
  };
}

export function resetThemesGraphicCategoryState() {
  return {
    type: THEMES_GRAPHIC_CATEGORY_RESET_STATE,
  };
}

export function getThemesGraphicCategoryAsync(isOccasion, designtid, sizeid, layoutId) {
  return (dispatch, getState) => {
    dispatch(themesGraphicCategoryAsyncActionStart());
    return api.request(`theme/list?isOccasion=${ isOccasion }&designtid=${ designtid }&sizeid=${ sizeid }&layoutId=${layoutId!=undefined?layoutId:-1}`, 'get')
    .then((data) => {
    	data.map((themesGraphicCategory) => {
    	  		themesGraphicCategory.imageURL = `${ s3BucketURL }`+'system/theme-graphic-images/'+themesGraphicCategory.typeItemTextKey+'.png';
    	  		themesGraphicCategory.iconURL = `${ s3BucketURL }`+'system/theme-graphic-icons/'+themesGraphicCategory.typeItemTextKey+'.png';
    		    });
      dispatch(themesGraphicCategoryAsyncActionSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(themesGraphicCategoryAsyncActionError('Unable to get Graphic Category Themes'));
      throw (err);
    });
  };
}

export function getThemesGraphicCategoryThemeAsync(isOccasion, layoutId) {
  return (dispatch, getState) => {
    dispatch(themesGraphicCategoryAsyncActionStart());
    return api.request(`theme/list?isOccasion=${ isOccasion }&layoutId=${layoutId!=undefined?layoutId:-1}`, 'get')
    .then((data) => {
    	data.map((themesGraphicCategory) => {
    		themesGraphicCategory.imageURL = `${ s3BucketURL }`+'system/theme-graphic-images/'+themesGraphicCategory.typeItemTextKey+'.png';
    		themesGraphicCategory.iconURL = `${ s3BucketURL }`+'system/theme-graphic-icons/'+themesGraphicCategory.typeItemTextKey+'.png';
  	    });
      dispatch(themesGraphicCategoryAsyncActionSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(themesGraphicCategoryAsyncActionError('Unable to get Graphic Category Themes'));
      throw (err);
    });
  };
}

export function getOneThemeGraphicCategoryAsync(themeId, layoutId) {
  return (dispatch, getState) => {
    dispatch(themesGraphicCategoryAsyncActionStart());
    return api.request(`theme/design/DesignTemplates?themeid=${ themeId }&layoutId=${layoutId!=undefined?layoutId:-1}`, 'get')
    .then((data) => {
      let typeItemGraphicCategoryData = getState().themesGraphicCategory.get('data');
      let themeGraphicCategoryData = Theme.getThemeDataByTypeItemId(typeItemGraphicCategoryData, themeId).first().setIn(['designTemplates'], DesignTemplates(data));
      let replacedData = Theme.setThemeDataByTypeItemId(typeItemGraphicCategoryData, themeId, themeGraphicCategoryData.get('designTemplates'));

      dispatch(themesGraphicCategoryAsyncActionSuccess(replacedData));
      return themeGraphicCategoryData;
    })
    .catch((err) => {
      dispatch(themesGraphicCategoryAsyncActionError('Unable to get Graphic Category Theme'));
      throw (err);
    });
  };

}
